'use client';

import { FC } from 'react';
import { IconButton } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

const addButtonSx = {
  height: '40px',
  width: '40px',
  backgroundColor: 'primary.main',
  color: 'white',
  border: 1,
  borderColor: 'primary.main',
  borderRadius: 1,
  '&:hover': {
    backgroundColor: 'primary.dark',
    borderColor: 'primary.dark',
  },
} as const;

export type MaterialCreateAddButtonProps = {
  onClick: () => void;
  title?: string;
};

/** Add-material control; render only when parent has confirmed canCreateMaterial. */
export const MaterialCreateAddButton: FC<MaterialCreateAddButtonProps> = ({ onClick, title = 'Add new material' }) => (
  <IconButton onClick={onClick} size="small" sx={addButtonSx} title={title}>
    <AddIcon fontSize="small" />
  </IconButton>
);
